import type { MouseEvent } from 'react';
import { Body1Strong, Link as FluentLink } from '@fluentui/react-components';
import type { TMap } from '@shared/types';
import { QueryLink } from '../QueryLink';

type TProps = {
  label: string;
  isCurrent: boolean;
  // The URL parameters that show a version.
  getParams: (versionId: string) => TMap<string, string | undefined>;
  versionId?: string;
  // Takes over a plain click, e.g. to save first; a modified click stays with the browser.
  onSelect?: (versionId: string) => void;
};

const isPlainClick = (event: MouseEvent) =>
  event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;

const VersionLinkRow = ({ label, isCurrent, getParams, versionId, onSelect }: TProps) => (
  <p className="flex">
    <span className="block w-32 flex-shrink-0">{label}:</span>
    {!versionId ? (
      <Body1Strong>-</Body1Strong>
    ) : isCurrent ? (
      <Body1Strong>{versionId}</Body1Strong>
    ) : (
      <QueryLink
        params={getParams(versionId)}
        replace
        onClick={
          onSelect &&
          ((event) => {
            if (!isPlainClick(event)) return;
            event.preventDefault();
            onSelect(versionId);
          })
        }
      >
        <FluentLink>
          <Body1Strong>{versionId}</Body1Strong>
        </FluentLink>
      </QueryLink>
    )}
  </p>
);

export default VersionLinkRow;
